import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/authContext";

const AuthGuard = ({ children }) => {
  const { isAuthenticated, isEmailVerified, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoading) return;

    const publicRoutes = ["/login", "/verify-email", "/forgot-password", "/reset-password"];
    const isPublicRoute = publicRoutes.some(route => 
      location.pathname.startsWith(route)
    );

    if (!isAuthenticated && !isPublicRoute) {
      navigate("/login", { state: { from: location } });
      return;
    }

    if (isAuthenticated && !isEmailVerified && location.pathname !== "/verify-email") {
      navigate("/verify-email", { state: { from: location } });
      return;
    }

    if (isAuthenticated && isEmailVerified && (location.pathname === "/login" || location.pathname === "/verify-email")) {
      navigate("/dashboard");
      return;
    }
  }, [isAuthenticated, isEmailVerified, isLoading, location.pathname, navigate, location]);

  return children;
};

export default AuthGuard;
